import "../tool.js";
/**
 * Load lifecycle:
 *  tool.setState - used by tools with more complicated state requirements. Most tools just pass the component context to their templates, so that's the default
 *  tool.render - by default updates the tool element with markup generated by tool template, overrid for react apps
 *  tool.bind - bind events to the tool or component here
 *  tool.unbind - unbind any events
 *
 * Update lifecycle
 *  tool.setState
 *  tool.update
 *  tool.rendered (if the component was rendered)
 *
 * General Notes
 *  - render/bind/unbind are only called on load, after that it's setcontext and update. update is
 *  - identical to render by default, but you can override it. the update lifecycle is only triggered if
 *  - another tool changes the splinter, so if your tool changes a context value, you update your view there.
 */

(function () {
  "use strict";

  Sparkle.PageBuilder.Tool({
    /**
     * @description Unique identifier for the tool component.
     */
    name: "color-picker",

    /**
     * @description The template file to use to load and render the component.
     * @see title-editor-template.hbs
     */
    templateId: "color-picker-template",

    /**
     * @name bind
     * @description
     * Bind the different event listeners to the component, and also add in
     *  any extra functionality to manage the slideshow
     * @param {HTMLElement} component
     */
    bind: function (component) {
      var me = this;
      var availableColors = []; // inherit the colors from the configuration settings.

      if ("available_colors" in this.config) {
        this.config.available_colors.forEach(function (color) {
          availableColors.push(color);
        });
      }

      availableColors.push(""); // add clear option

      var $input = jQuery(this.element).find("input");
      $input.spectrum({
        hideAfterPaletteSelect: true,
        showPaletteOnly: true,
        allowEmpty: true,
        togglePaletteOnly: false,
        palette: availableColors,
        change: function (color) {
          if (color) {
            color = color.toHexString();
          }

          me.component.save(color);
          me.component.render();
        },
      });
    },

    /**
     * @name bind
     * @description
     * Unbind the different event listeners to the component added during the
     *  initial bind step.
     * @param {HTMLElement} element
     */
    unbind: function (element) {
      var $input = jQuery(this.element).find("input");
      $input.spectrum("destroy");
    },
  });
})();
